var React = require('react');

function LinkInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 37 (3)"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group-37-(3)"},[React.createElement("rect",{"id":"Rectangle","fill":"#D8D8D8","opacity":"0","x":"0","y":"0","width":"52","height":"52","key":0}),React.createElement("circle",{"id":"Oval","stroke":"#BBAB91","cx":"26","cy":"26","r":"24.5","key":1}),React.createElement("path",{"d":"M27.8627,33.8367 C27.8627,29.1481 34.9676,25.9999 34.9676,25.9999 C34.9676,25.9999 27.8627,22.9174 27.8627,18.1901","id":"Path","stroke":"#BBAB91","key":2}),React.createElement("line",{"x1":"34.9676","y1":"26","x2":"15.5833","y2":"26","id":"Path","stroke":"#BBAB91","key":3})]))]);
}

LinkInline.defaultProps = {"width":"52px","height":"52px","viewBox":"0 0 52 52","version":"1.1"};

module.exports = LinkInline;

LinkInline.default = LinkInline;
